export const statisticsRoutesName = {
    statistics: "statistics",
};
